export const API_URL = 'https://api.getflashmultiservice.com';
